import Logging from '@serv/Logging'
import type { PiniaPluginContext, Store } from 'pinia'

const resetStores: Record<string, () => void> = {}

/**
 * Pinia plugin to track stores with a '$reset' method.
 * Logs an error if a store is missing the $reset method.
 */
export const piniaResetPlugin = (context: PiniaPluginContext) => {
    const store = context.store as Store & { $reset?: () => void }

    if (typeof store.$reset === 'function') {
        resetStores[store.$id] = store.$reset
    } else {
        const storeId = store.$id || 'unknown'
        const errorMessage = `Pinia store "${storeId}" is missing the required $reset method for the reset plugin.`
        Logging.error(errorMessage)
    }
}

/**
 * Calls the '$reset' method on all tracked stores.
 */
export const resetAllStores = () => {
    const storesToReset = Object.entries(resetStores)
    storesToReset.forEach(([storeId, resetFn]) => {
        try {
            resetFn()
        } catch (error: unknown) {
            let message = 'Unknown error'
            if (error instanceof Error) {
                message = error.message
            } else if (typeof error === 'string') {
                message = error
            }
            Logging.error(`Error calling tracked $reset function during global reset: storeId: ${storeId}, ${message}`)
        }
    })
}
